// extracted by mini-css-extract-plugin
module.exports = {"list":"_2224914","dividerText":"_2725eb4"};